<template>
  <Template
    name="剧情标签"
    shortName="标签"
    source="tag"
  />
</template>

<script setup>
import Template from './components-plot/Template'
</script>

<style lang="less" scoped>
</style>